// How long a conversation has been sitting, as the left pane shows it.
//
// COMPACT ON PURPOSE — "14h", not "14 hours ago". On an awaiting row the age
// is the loudest thing on the line, so it has to fit beside the participant
// name at a glance; the business problem this screen exists for is 7–22 hour
// weekend response times, which means HOURS are the unit that matters and a
// row reading "yesterday" hides exactly the thing being measured.
//
// Pure and framework-free so it unit-tests without a clock mock beyond `now`.
//
// NOTE: Components/EmailInboxPanel.jsx carries a private `timeAgo` with the
// same arithmetic and a different copy contract ("5m ago", and a locale date
// past a week). The two are not interchangeable as they stand and unifying
// them would change that panel's visible text, so it is left alone — see the
// recommendation in this change's hand-back rather than a second opinion
// quietly shipped here.

/** The full timestamp, for the `title` on a row whose age is abbreviated. */
export function exactWhen(iso) {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return date.toISOString().replace('T', ' ').slice(0, 16);
}

/**
 * "now" | "7m" | "14h" | "3d" — or '' when there is no usable timestamp.
 *
 * A future timestamp reads as "now" rather than a negative age: clock skew
 * between a mail server and this browser is real and a row showing "-1h"
 * looks like a bug in the screen instead of a message that just arrived.
 */
export function conversationAge(iso, now = Date.now()) {
  if (!iso) return '';
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '';

  const minutes = Math.floor((now - then) / 60000);
  if (minutes < 1) return 'now';
  if (minutes < 60) return `${minutes}m`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h`;

  return `${Math.floor(hours / 24)}d`;
}

export default conversationAge;
